<template>
    <div class="alert alert-info">
        <h4>Aún no hay información</h4>
    </div>
</template>
<script>
export default {
    
}
</script>